import api from "./api";
import { pedidoEmVoo } from "./pedidosEmVoo";

// Um GET /settings por vez, compartilhado.
//
// Três hooks (som de notificação, modo de gravação, mostrar não lidas) pedem
// a MESMA lista no primeiro carregamento — eram três requisições idênticas na
// abertura de toda tela. Só o pedido EM VOO é compartilhado (e morre na troca
// de sessão — ver pedidosEmVoo); cada hook continua com o próprio cache e o
// próprio fallback.
// Lê `/settings/interface`, não `/settings`: o GET inteiro é só do admin e o
// atendente levava 403 — caía no padrão e não via o que a empresa escolheu.
export const buscarSettings = () =>
	pedidoEmVoo("settings", () => api.get("/settings/interface"));
